/* LMM PDP — Auswählbarer Sparrechner (Modus 2 + 3), isoliert von lmm-pdp-inline.js.
 *
 * Deckt zwei NEUE Rechner-Modi ab (Modus 1 = Retrofit mit belegtem replaces_wattage bleibt
 * im inline.js-Rechner [data-lmm-calc-vat] und wird hier NICHT angefasst):
 *
 *  Modus 2 — LED-Lampe ohne replaces_wattage: data-lmm-fixed-side="new" (diese LED = fixe
 *            niedrige Leistung), Auswahl = bisherige Lampe (25/40/.../100 W). KEIN „ersetzt X W"-
 *            Claim — der Nutzer wählt seine bisherige Lampe selbst. Payback auf LED-Preis.
 *  Modus 3 — klassische Leuchtstoffröhre → LED: data-lmm-fixed-side="old" (diese Röhre = fixe
 *            hohe Leistung), Auswahl = ANGENOMMENE LED-Leistung (Beispielwert, keine konkrete
 *            Ersatzröhre behauptet). Kein Payback (kein LED-Preis → data-lmm-unit-gross fehlt).
 *
 * Formeln + MwSt.-Ansicht 1:1 wie der inline.js-Rechner (0,344 kg CO₂/kWh, 8 h/Tag, 0,35 €/kWh
 * Default). Negative Differenz wird auf 0 geklemmt (z. B. wenn angenommene LED ≥ Artikelleistung).
 * Erfindet keine Produktwerte: fixe Leistung kommt aus specs.wattage, der Vergleichswert ist eine
 * sichtbare Nutzer-Auswahl.
 */
(function () {
  'use strict';
  var nodes = document.querySelectorAll('[data-lmm-savings-calc]');
  if (!nodes.length) return;

  function num(v, d) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) ? n : d; }

  Array.prototype.forEach.call(nodes, function (calc) {
    var vatRate = num(calc.getAttribute('data-lmm-vat-rate'), 19) / 100;
    var VAT_F = 1 + vatRate;
    /* TUEV-02 Nachlauf (2026-08-17): Produkt-MwSt. getrennt von der Strom-MwSt.
       Fallback = bisheriges Verhalten, falls das Attribut fehlt. */
    var shopVatRate = num(calc.getAttribute('data-lmm-shop-vat-rate'), vatRate * 100) / 100;
    var SHOP_VAT_F = 1 + shopVatRate;
    var FIXED_W = num(calc.getAttribute('data-lmm-fixed-w'), 0);
    var FIXED_SIDE = (calc.getAttribute('data-lmm-fixed-side') || 'new'); /* 'new' (M2) | 'old' (M3) */
    var UNIT_GROSS = num(calc.getAttribute('data-lmm-unit-gross'), 0);    /* 0 => kein Payback */
    var CO2 = 0.344;

    var sel = calc.querySelector('[data-lmm-savings-watt]');
    var elTubes = calc.querySelector('[data-lmm-calc-tubes]');
    var elHours = calc.querySelector('[data-lmm-calc-hours]');
    var elHoursOut = calc.querySelector('[data-lmm-calc-hours-out]');
    var elPrice = calc.querySelector('[data-lmm-calc-price]');
    var elPriceLabel = calc.querySelector('[data-lmm-price-label]');
    var elEquiv = calc.querySelector('[data-lmm-vat-equiv]');
    var vatBtns = Array.prototype.slice.call(calc.querySelectorAll('[data-lmm-vat-mode]'));
    var vatTags = Array.prototype.slice.call(calc.querySelectorAll('[data-lmm-vat-tag]'));
    var outKwh = calc.querySelector('[data-lmm-out-kwh]');
    var outCo2 = calc.querySelector('[data-lmm-out-co2]');
    var outEurYear = calc.querySelector('[data-lmm-out-eur-year]');
    var outPay = calc.querySelector('[data-lmm-out-payback]');
    var outPayBasis = calc.querySelector('[data-lmm-out-payback-basis]');
    var outOldW = calc.querySelector('[data-lmm-out-old-w]');
    var outNewW = calc.querySelector('[data-lmm-out-new-w]');
    var outDiff = calc.querySelector('[data-lmm-out-diff]');

    var vatMode = 'incl';
    var tariffGross = 0.35;

    var fmtInt = function (n) { return Math.round(n).toLocaleString('de-DE'); };
    var fmtEur = function (n) { return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };
    var fmtW = function (n) { return (Math.round(n * 10) / 10).toLocaleString('de-DE') + ' W'; };

    function watts() {
      var c = sel ? num(sel.value, 0) : 0;
      return FIXED_SIDE === 'old' ? { old: FIXED_W, neu: c } : { old: c, neu: FIXED_W };
    }

    var syncTariff = function () {
      var v = num(elPrice && elPrice.value, NaN);
      if (!isFinite(v)) return;
      v = Math.max(0.01, Math.min(2, v));
      tariffGross = vatMode === 'incl' ? v : v * VAT_F;
    };

    var recalc = function () {
      var tubes = Math.max(1, Math.min(200, parseInt(elTubes && elTubes.value, 10) || 1));
      var hours = Math.max(1, Math.min(24, parseFloat(elHours && elHours.value) || 8));
      var price = vatMode === 'incl' ? tariffGross : tariffGross / VAT_F;
      var unit = (vatMode === 'incl' || shopVatRate === 0)
        ? UNIT_GROSS
        : UNIT_GROSS / SHOP_VAT_F;
      var tag = vatMode === 'incl' ? 'inkl. MwSt.' : 'exkl. MwSt.';
      var shopTag = shopVatRate === 0 ? 'ohne MwSt.' : tag;

      var w = watts();
      var diffW = Math.max(0, w.old - w.neu);
      var diffKw = diffW / 1000;
      var kwhYear = diffKw * hours * 365 * tubes;
      var eurYear = kwhYear * price;
      var payMonths = (UNIT_GROSS > 0 && eurYear > 0) ? (unit * tubes) / eurYear * 12 : 0;
      var co2y = kwhYear * CO2;

      if (elHoursOut) elHoursOut.textContent = hours.toLocaleString('de-DE') + ' h/Tag';
      if (outKwh) outKwh.textContent = fmtInt(kwhYear) + ' kWh';
      if (outCo2) {
        outCo2.textContent = co2y >= 1000
          ? '≈ ' + (co2y / 1000).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' t CO₂'
          : '≈ ' + fmtInt(co2y) + ' kg CO₂';
      }
      if (outEurYear) outEurYear.textContent = fmtEur(eurYear);
      if (outPay) {
        outPay.textContent = payMonths < 1
          ? 'unter 1 Monat'
          : 'ca. ' + fmtInt(payMonths) + (Math.round(payMonths) === 1 ? ' Monat' : ' Monate');
      }
      if (outPayBasis) outPayBasis.textContent = 'auf Basis von ' + fmtEur(unit) + ' ' + shopTag;
      if (outOldW) outOldW.textContent = fmtW(w.old);
      if (outNewW) outNewW.textContent = fmtW(w.neu);
      if (outDiff) outDiff.textContent = fmtW(diffW);
      vatTags.forEach(function (t) { t.textContent = tag; });
      if (elPriceLabel) elPriceLabel.textContent = vatMode === 'incl' ? 'Strompreis inkl. MwSt.' : 'Strompreis exkl. MwSt.';
      if (elEquiv) {
        elEquiv.textContent = vatMode === 'incl'
          ? 'entspricht ca. ' + fmtEur(tariffGross / VAT_F) + '/kWh exkl. MwSt.'
          : 'entspricht ca. ' + fmtEur(tariffGross) + '/kWh inkl. MwSt.';
      }
    };

    var setVat = function (m) {
      if (m === vatMode) return;
      vatMode = m;
      var shown = m === 'incl' ? tariffGross : tariffGross / VAT_F;
      if (elPrice) elPrice.value = (Math.round(shown * 100) / 100).toFixed(2);
      vatBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.lmmVatMode === m ? 'true' : 'false'); });
      recalc();
    };

    ['input', 'change'].forEach(function (e) {
      if (elPrice) elPrice.addEventListener(e, syncTariff);
      calc.addEventListener(e, recalc);
    });
    vatBtns.forEach(function (b) { b.addEventListener('click', function () { setVat(b.dataset.lmmVatMode); }); });
    recalc();
  });
})();
